<template>
  <div v-if="broadcastCategoryName && broadcastCategoryDescription">
    <div class="shadow-sm bg-white p-6 rounded mt-14">
      <p v-if="!hideCategoryTitle" class=" text-center text-gray-900 text-2xl mb-6 font-bold">{{ broadcastCategoryName }} Broadcast</p>
      <div class="broadcast-description" v-html="broadcastCategoryDescription"></div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      broadcastCategoryName: {
        type: String,
        default: () => "Broadcast Category"
      },
      broadcastCategoryDescription: {
        type: String,
        default: () => ""
      },
      hideCategoryTitle: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style>
.broadcast-description h2 {
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.broadcast-description h3 {
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 700;
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
}

.broadcast-description p {
  line-height: 1.7;
  margin-bottom: 1rem;
}

.broadcast-description ul {
  list-style: disc;
  margin-left: 1.25rem;
  margin-bottom: 1rem;
}

.broadcast-description li {
  margin-bottom: 0.35rem;
  line-height: 1.6;
}

.broadcast-description a {
  color: #dc2626;
  text-decoration: underline;
}

.broadcast-description a:hover {
  color: #b91c1c;
}
</style>
